// Se muestra cuando hay una sesión válida pero el rol no es admin_empresa
// ni editor_empresa (ver guardas.js). Caso esperado, por ejemplo, si un
// super_admin abre por error la URL del Panel Cliente en vez de la del
// Panel Super Admin.

import { cerrarSesion } from '../estado-sesion.js';

export function vistaSinPermiso(contenedor) {
  contenedor.innerHTML = `
    <div class="pf-login">
      <div class="pf-tarjeta pf-login__tarjeta" style="text-align: center;">
        <h1 class="pf-login__titulo">Sin acceso</h1>
        <p class="pf-texto-suave">
          Tu cuenta no tiene permisos de administrador de esta tienda.
          Si crees que esto es un error, contacta a soporte.
        </p>
        <button type="button" class="pf-boton pf-boton--secundario" id="pf-btn-salir-sin-permiso">
          Cerrar sesión
        </button>
      </div>
    </div>
  `;

  contenedor.querySelector('#pf-btn-salir-sin-permiso').addEventListener('click', async () => {
    await cerrarSesion();
  });
}
